import { render, staticRenderFns } from "./SiteCentros.vue?vue&type=template&id=327bb59e"
import script from "./SiteCentros.vue?vue&type=script&lang=js"
export * from "./SiteCentros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports